import { render, staticRenderFns } from "./addAndEditRole.vue?vue&type=template&id=fb33415a&scoped=true"
import script from "./addAndEditRole.vue?vue&type=script&lang=js"
export * from "./addAndEditRole.vue?vue&type=script&lang=js"
import style0 from "./addAndEditRole.vue?vue&type=style&index=0&id=fb33415a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb33415a",
  null
  
)

export default component.exports